
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 2.25h-11a1 1 0 00-1 1v8.5a1 1 0 001 1h11a1 1 0 001-1v-8.5a1 1 0 00-1-1z","stroke":"#56BFC7","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M.5 3.5l5.86 5a1 1 0 001.28 0l5.86-5","stroke":"#56BFC7","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    